import { HandleTextChange, HandlePassChange, HandleSelectChange, SetCookieFunction, CallAPI, RemoveAllCookies } from '../utils/util.js';
import { React, Component } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Alert from 'react-bootstrap/Alert';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate  = useNavigate();
        let params    = useParams();
        return <Component {...props} router={{ location, navigate, params }} />;
    }
    return ComponentWithRouterProp;
}

class CenterDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = { centers: [] };
        this.getRows = this.getRows.bind(this);
    }

    componentDidMount() {
        CallAPI({}, "centers/list", 'GET', (res) => {
            res.sort((a, b) => a.centerID - b.centerID);
            if (res.length > 0) {
                this.props.onInit(res[0].centerID);
            }
            this.setState({ centers: res });
        });
    }

    getRows() {
        return this.state.centers.map(({ centerID, centerName }) => (
            <option key={centerID} value={centerID}>{centerName}</option>
        ));
    }

    render = () => (
        <select
            name="centerID"
            className="centerland"
            onChange={(e) => this.props.onSelectChange(e)}
            aria-label="Select center"
        >
            {this.getRows()}
        </select>
    );
}

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            centerID: null,
            email: null,
            logpass: null,
            userMessage: null,
            loading: false
        };
        RemoveAllCookies();
        this.handleTextChange   = HandleTextChange.bind(this);
        this.handleSubmit       = this.handleSubmit.bind(this);
        this.handleSelectChange = HandleSelectChange.bind(this);
        this.handlePassChange   = HandlePassChange.bind(this);
        this.initCenter         = this.initCenter.bind(this);
    }

    initCenter(centerId) {
        this.setState({ centerID: centerId });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({ loading: true, userMessage: null });

        const toSend = {
            centerID:  this.state.centerID,
            email:     this.state.email,
            password:  this.state.logpass
        };

        CallAPI(toSend, "users/login", 'POST', (res) => {
            if (res.success) {
                SetCookieFunction({ name: "User", value: {
                    fname:  res.fname,
                    lname:  res.lname,
                    id:     res.id,
                    token:  res.token,
                    type:   res.type,
                    admin:  res.admin,
                    tz:     res.timezone
                }});
                SetCookieFunction({ name: "Center", value: {
                    id:   res.centerid,
                    name: res.centername
                }});
                this.props.router.navigate("/");
            } else {
                this.setState({ loading: false, userMessage: "Username or Password is incorrect. Please try again." });
            }
        }, () => {
            this.setState({ loading: false, userMessage: "Username or Password is incorrect. Please try again." });
        });
    }

    render = () => (
        <div className="wow">
            <div className="boxu">
                <h2 className="signIn">Sign In</h2>
                <p className="signInMessage">Welcome back. Please sign in to continue.</p>

                {this.state.userMessage && (
                    <Alert variant="danger" style={{ marginBottom: '16px' }}>
                        {this.state.userMessage}
                    </Alert>
                )}

                <form onSubmit={(e) => this.handleSubmit(e)} noValidate>
                    <div style={{ marginBottom: '14px' }}>
                        <label className="signInBox" htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            required
                            placeholder="you@example.com"
                            onChange={(e) => this.handleTextChange(e)}
                            autoComplete="email"
                        />
                    </div>

                    <div style={{ marginBottom: '14px' }}>
                        <label className="signInBox" htmlFor="logpass">Password</label>
                        <input
                            type="password"
                            id="logpass"
                            name="logpass"
                            required
                            placeholder="••••••••"
                            onChange={(e) => this.handlePassChange(e, this)}
                            autoComplete="current-password"
                        />
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <label className="signInBox" htmlFor="centerID">Center</label>
                        <p style={{ fontSize: '12px', color: '#64748b', marginTop: '2px', marginBottom: '6px' }}>
                            Only applies to executives. Other users are automatically assigned to their center.
                        </p>
                        <div className="centerDropdown" style={{ margin: 0 }}>
                            <CenterDropdown
                                onSelectChange={this.handleSelectChange}
                                onInit={this.initCenter}
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        className="logSubmit"
                        disabled={this.state.loading}
                    >
                        {this.state.loading ? "Signing in…" : "Sign In"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default withRouter(Login);
